/**
 * resolveApiBase — base de API à prova de "mixed content".
 *
 * INSTALLER-LOGIN-NETWORK-DIAG-1: numa página servida via HTTPS, um fetch para uma
 * base http:// (ex.: build com VITE_API_URL=http://45.168.47.110:8000) é BLOQUEADO
 * pelo browser → "Failed to fetch" (era o erro do login no /installer no celular/
 * BlueStacks, e em qualquer cliente "fresco" sem config salva). O proxy (Caddy) já
 * roteia /api/* e /health no MESMO domínio, então, nesse caso, caímos para
 * same-origin (base "" → caminho relativo /api/...): sem mixed content e sem CORS.
 *
 * Em páginas http (bancada/dev) ou com base https explícita, respeita a base. PURO.
 *
 * @param {string} apiUrl       base configurada (loadConfig().apiUrl)
 * @param {string} pageProtocol window.location.protocol ("https:" | "http:" | "")
 * @returns {string} base efetiva ("" = same-origin/relativo)
 */
export function resolveApiBase(apiUrl, pageProtocol) {
  const base = (apiUrl || "").trim();
  if (pageProtocol === "https:" && /^http:\/\//i.test(base)) return "";
  return base;
}
